import script from "./OperatorApplicationSideMenuItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorApplicationSideMenuItem.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorApplicationSideMenuItem.vue?vue&type=style&index=0&id=dcbda86c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcbda86c"]])

export default __exports__